import { lazy } from 'react';

export const PlanPage = lazy(() =>
  import('./ui/PlanPage').then((module) => ({
    default: module.PlanPage,
  }))
);
